<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button autoHide="true" data-cy="myPairedListings-hdr-menuBtn"></ion-menu-button>

    </ion-buttons>
    <ion-buttons slot="end">
      <app-profile-component data-cy="myPairedListings-hdr-profileBtn"
        (click)="openMyProfile()"></app-profile-component>
      <ion-button (click)="openHelp()" data-cy="myPairedListings-hdr-helpBtn">
        <ion-icon slot="icon-only" name="help-circle-sharp"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title *ngIf="userRole === 'lender'" data-cy="myPairedListings-hdr-title">Paired Listings</ion-title>
    <ion-title *ngIf="userRole === 'agentAdmin'" data-cy=" myPairedListings-hdr-title">Listings</ion-title>
  </ion-toolbar>

</ion-header>

<ion-content>
  <div class="myPairedListings">

    <div class="spacer-10"></div>

    <div *ngIf="!showSkeleton" class="blockBox centerBox mainContentBox padding">

      <div *ngIf="(myListings.length !== 0 || user?.enableAgentsListingsResultsFiltering) && !showRefresh">

        <div class="listing-items-header" padding-top padding-horizontal data-cy="myPairedListings-title">
          <span>{{listingsLabel}}</span>
          <ion-icon *ngIf="user?.enableAgentsListingsResultsFiltering" class="filterIcon" name="options-outline"
            tappable (click)="toggleFilterVisbility()"></ion-icon>
          <ion-button tappable (click)="createNewListing()" color="primary"
            data-cy="myListings-filledList-addListingBtn">
            <ion-icon class="ion-margin-end" name="add-sharp"></ion-icon>
            <ion-label>Add Listing </ion-label>
          </ion-button>
        </div>



        <div *ngIf="user?.enableAgentsListingsResultsFiltering">

          <div class="spacer-10"></div>

          <algolia-search-with-filters [instanceName]="instanceNameAdvancedSearch"
            [childComponent]="algoliaListingSearchWithFilters" [noResultsMessage]="'No results found.'"
            [restrictStates]="false"
            [locationData]="['listingSnapshot.locations.lvl0', 'listingSnapshot.locations.lvl1', 'listingSnapshot.locations.lvl2']" />


          <ng-template #algoliaListingSearchWithFilters let-hit>
            <app-paired-listing-item [attr.data-index]="i" (onEvents)="listingEvents($event)"
              class="listing-item borderBox" [listing]="hit.listingSnapshot" [listingId]="hit.listingId"
              [content]="content" />
          </ng-template>
        </div>

        <ion-list *ngIf="!user?.enableAgentsListingsResultsFiltering" class="listing-items" padding>

          <app-paired-listing-item *ngFor="let listing of finalResPaginated; trackBy: listingsTrackByFn; let i = index"
            [attr.data-index]="i" (onEvents)="listingEvents($event)" class="listing-item borderBox" [listing]="listing"
            [listingId]="listing.id" [content]="content">
          </app-paired-listing-item>

          <div class="spacer-50"></div>
        </ion-list>


        <ion-infinite-scroll (ionInfinite)="onIonInfinite($event)">
          <ion-infinite-scroll-content loadingSpinner="crescent"></ion-infinite-scroll-content>
        </ion-infinite-scroll>

        <div *ngIf="!user?.regionalLender && user?.role === 'lender'" class="pairMoreDiv">
          <div>
            <ion-label data-cy="myPairedListings-pairMoreAgentsLbl">Want more paired listings?</ion-label>
          </div>
          <div>
            <ion-button (click)="goToPairedAgents($event)" data-cy="myPairedListings-pairMoreAgentsBtn">Pair More
              Agents</ion-button>
          </div>

        </div>

      </div>

      <div class="spacer-50"></div>

      <div *ngIf="!showSkeleton && showRefresh" class="noLeadsDiv blockBox centerBox centerAlign">
        <ion-label>Loading</ion-label>
        <div class="padding">
          <ion-spinner name="crescent"></ion-spinner>
        </div>


      </div>

      <div *ngIf="showRefresh" class="refresh-holder">
        <ion-button *ngIf="!loading" (click)="refreshPage()">Refresh</ion-button>
      </div>

    </div>

    <div *ngIf="showSkeleton && !showRefresh && !addListings" class="skeleton-holder">

      <div class="no-listings-wrapper blockBox centerBox centerAlign">
        <img src="/assets/imgs/newListingsIcon.png" />
        <div class="label">
          Want to create and manage listings for your team? Start by inviting them. <strong class="link"
            (click)="learnMore()">Learn more</strong>
        </div>
        <ion-button class="get-started-button" ion-button tappable (click)="pairAgents()" color="primary">
          Get Started
        </ion-button>
      </div>
    </div>

    <div *ngIf="showSkeleton && !showRefresh && addListings" class="skeleton-holder"
      data-cy="myListings-emptyList-skeleton">
      <div class="no-listings-wrapper blockBox centerBox centerAlign">
        <img src="/assets/imgs/empty_listing.svg" data-cy="myListings-emptyList-img" />
        <div class="label" data-cy="myListings-emptyList-dscr">
          Hey, it’s lonely in here.
        </div>
        <ion-button tappable (click)="createNewListing()" color="primary" data-cy="myListings-emptyList-addListingBtn">
          <ion-label>Add Listing</ion-label>
          <ion-icon class="ion-margin-start" name="add-sharp"></ion-icon>
        </ion-button>
      </div>
    </div>

    <div class="spacer-10"></div>
  </div>
</ion-content>